<app-swap-modal-summary-item
  [type]="SwapVehicleType.PRIMARY"
  [swap]="swap()"
  [technicalPoints]="technicalPoints()"
  [identifierColor]="isDouble() ? 'blue' : null"
  [isDouble]="isDouble()"
></app-swap-modal-summary-item>

@if (isDouble()) {
  <app-swap-modal-summary-item
    [type]="SwapVehicleType.SECONDARY"
    [swap]="swap()"
    [technicalPoints]="technicalPoints()"
    identifierColor="sea-green"
    [isDouble]="isDouble()"
  ></app-swap-modal-summary-item>
}
